import { create } from "zustand/esm";
import { FunFactType } from "./FunFactsSection";

interface FunFactsStore {
    funFacts:
        | {
              [postId: string]: FunFactType[] | undefined;
          }
        | undefined;
    setFunFacts: (postId: string, funFacts: FunFactType[]) => void;
}

export const useFunFactsStore = create<FunFactsStore>()((set, get) => ({
    funFacts: undefined,
    setFunFacts: (postId, funFactsData) => {
        const previousData = get().funFacts ?? {};
        previousData[postId] = funFactsData;
        set({
            funFacts: previousData,
        });
    },
}));
